"use client";

import { forwardRef, useState } from "react";
import { cn } from "~/lib/utils";

export interface TooltipProps {
	children: React.ReactNode;
	content: string;
	className?: string;
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
	({ children, content, className }, ref) => {
		const [isVisible, setIsVisible] = useState(false);

		return (
			<div
				ref={ref}
				className={cn("relative inline-block", className)}
				onMouseEnter={() => setIsVisible(true)}
				onMouseLeave={() => setIsVisible(false)}
			>
				{children}
				{isVisible && (
					<div
						className="absolute bottom-full left-1/2 z-50 mb-2 -translate-x-1/2 whitespace-normal rounded-md border border-[rgba(0,0,45,0.09)] bg-[rgba(255,255,255,0.98)] px-3 py-2 text-sm leading-5 text-[#1c2024] shadow-lg"
						style={{
							width: "360px",
							maxWidth: "360px",
						}}
					>
						<div className="relative">
							<p className="text-sm leading-5">{content}</p>
							{/* Arrow pointing down */}
							<div
								className="absolute left-1/2 top-full -translate-x-1/2"
								style={{
									borderTop: "6px solid rgba(0,0,45,0.09)",
									borderLeft: "6px solid transparent",
									borderRight: "6px solid transparent",
								}}
							>
								<div
									className="absolute left-1/2 top-[-7px] -translate-x-1/2"
									style={{
										borderTop:
											"5px solid rgba(255,255,255,0.98)",
										borderLeft: "5px solid transparent",
										borderRight: "5px solid transparent",
									}}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	},
);

Tooltip.displayName = "Tooltip";

export { Tooltip };

